import { IJxtEventSummary } from './types';
import JxtEventColor from '../JxtEventColor';

const JxtEventSummary = ({ title, color }: IJxtEventSummary) => {
  return (
    <div className="flex items-center gap-3 text-title-m text-neutral-140 font-medium">
      <JxtEventColor color={color} />
      {/* Up to two lines so a regular title stays readable, a longer one is cut with an ellipsis */}
      <span className="min-w-0 line-clamp-2 wrap-break-word" title={title}>
        {title}
      </span>
    </div>
  );
};

export default JxtEventSummary;
